module.exports = __webpack_public_path__ + "static/calendar-99903662a7761c81696e7a75bbd336d2.png";